module.exports = __webpack_public_path__ + "img/send.3eedc245.png";